import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

const WrapperTextField = styled(TextField)`
  width: 100%;
  margin-top: ${(props) =>
    props.marginLabelTop ? `${props.marginLabelTop}px` : '20px !important'};

  .MuiInputLabel-root {
    font-size: 20px;
    line-height: 26px;
    color: #2c2c2c;
    font-family: outfit_semiBold;
    // width:100%;
  }

  .MuiInputLabel-root.Mui-focused {
    color: #292d32;
  }

  .MuiFormControl-root {
    position: relative;
  }

  .MuiInput-root {
    border: 1px solid ${(props) => (props.errorText ? '#EE3232' : '#DDDDDD')};
    border-radius: 8px;
    ${(props) =>
      !props.multiline &&
      `
			height: ${props.height ? `${props.height}px` : '50px'};
			padding: 15px;
		`}
    margin-top: ${(props) =>
      props.marginTop ? `${props.marginTop}px` : '25px'};
    font-family: Inter_Regular;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;

    ${(props) =>
      props.bgColor &&
      `
	 	    background-color:  ${props.bgColor};
	    `}

    ${(props) =>
      props.borderNone &&
      `
	 	    border: none;
	    `}

		&:before, &:after {
      border: none !important;
    }

    .MuiInput-input {
      color: ${(props) =>
        props.placeholdercolor ? props.placeholdercolor : '#a4aab2'};
      font-family: outfit_regular;
      font-size: 16px;
      line-height: 16px;
      padding: ${(props) => (props.multiline ? '15px' : '0')};

      ${(props) =>
        props.multiline &&
        `
				min-height: ${props.height ? `${props.height}px` : '80px'}; /* For multiline, define a min height */
				line-height: 1.5; /* Better line spacing for multiline content */
				overflow-y:auto !important;
			    max-height: ${props.height ? `${props.height}px !important` : '80px'};
			`}
    }
  }

  .MuiInput-root.Mui-focused {
    color: ${(props) => props.theme.darkSecondary};

    .MuiInput-input {
      color: ${(props) => props.theme.darkSecondary};
    }

    &:before,
    &:after {
      border: none !important;
    }
  }
`;

const WrapperErrorDiv = styled.div`
  font-size: 16px;
  color: red;
  line-height: 24px;
  font-family: outfit_regular;
  margin-top: 5px;
  position: absolute;
  bottom: -23px;
`;

const WrapperHelperDiv = styled.div`
  color: #292d32;
  margin-top: 2px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  font-family: Inter_Regular;
`;

function LabelWithInput({ containerProps, ...props }) {
  return (
    <FormControl fullWidth>
      <WrapperTextField
        id="standard-required"
        variant="standard"
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        multiline={props.multiline}
        {...props}
      />

      {props.errorText && <WrapperErrorDiv>{props.errorText}</WrapperErrorDiv>}

      {props.helperInfoPassword && (
        <WrapperHelperDiv>
          <div>
            <FormattedMessage id="register.helperText" />
          </div>
        </WrapperHelperDiv>
      )}
    </FormControl>
  );
}

LabelWithInput.defaultProps = {
  borderRadius: 4,
  fontSize: 16,
  textColor: '#1E1E1E',
};

export default LabelWithInput;
